// import React from "react";

// const rewards = [
//   {
//     name: "Mike Ross",
//     reward: "1 Year Membership",
//     status: "Earned",
//     date: "05 Jul 2024",
//   },
//   {
//     name: "Augustus Waters",
//     reward: "1 Year Membership",
//     status: "Earned",
//     date: "05 Jul 2024",
//   },
//   {
//     name: "Hazel Grace",
//     reward: "1 Year Membership",
//     status: "Pending",
//     date: "06 Jul 2024",
//   },
//   {
//     name: "Julia Anna",
//     reward: "1 Year Membership",
//     status: "Redeemed",
//     date: "07 Jul 2024",
//   },
// ];

// const ReferralRewards = () => {
//   return (
//     <div className="rewards-page-wrappe">
//       <div className="rewards-container">

//         {/* Header */}
//         <h2 className="rewards-title">Your Referral Rewards</h2>
//         <p className="rewards-subtitle">
//           Track rewards earned by inviting your friends
//         </p>

//         {/* Summary Cards */}
//         <div className="rewards-summary">
//           <div className="summary-card">
//             <h3>4 Years</h3>
//             <p>Total Earned</p>
//           </div>
//           <div className="summary-card">
//             <h3>1</h3>
//             <p>Pending</p>
//           </div>
//           <div className="summary-card">
//             <h3>1</h3>
//             <p>Redeemed</p>
//           </div>
//         </div>

//         {/* Rewards List */}
//         <div className="rewards-list">
//           <h4>Reward History</h4>

//           {rewards.map((item, index) => (
//             <div className="reward-item" key={index}>
//               <div className="reward-left">
//                 <div className="avatar">{item.name.charAt(0)}</div>
//                 <div>
//                   <strong>{item.name}</strong>
//                   <p>{item.reward}</p>
//                 </div>
//               </div>

//               <div className="reward-right">
//                 <span
//                   className={`status ${item.status.toLowerCase()}`}
//                 >
//                   {item.status}
//                 </span>
//                 <small>{item.date}</small>
//               </div>
//             </div>
//           ))}
//         </div>

//       </div>
//     </div>
//   );
// };

// export default ReferralRewards;


// import React from "react";

// const ReferralRewards = () => {
//   return (
//     <div className="card p-4">
//       <h4 className="mb-3">🎁 Refer & Earn</h4>

//       <p>Share your referral code with friends</p>

//       <div className="d-flex align-items-center mb-3">
//         <input
//           type="text"
//           value="REF-NIKITA123"
//           readOnly
//           className="form-control me-2"
//         />
//         <button className="btn btn-success">Copy</button>
//       </div>

//       <ul>
//         <li>✅ You get ₹100 coupon after friend’s first order</li>
//         <li>✅ Friend gets ₹50 welcome coupon</li>
//       </ul>

//       <div className="alert alert-info mt-3">
//         Coupons will be added automatically after successful order.
//       </div>
//     </div>
//   );
// };

// export default ReferralRewards;


// import React from "react";

// const rewards = [
//   {
//     name: "Augustus Waters",
//     reward: "₹100 Coupon",
//     status: "Earned",
//     date: "05 Jul 2024",
//   },
//   {
//     name: "Hazel Grace",
//     reward: "₹100 Coupon",
//     status: "Pending",
//     date: "06 Jul 2024",
//   },
//   {
//     name: "Julia Anna",
//     reward: "₹100 Coupon",
//     status: "Redeemed",
//     date: "07 Jul 2024",
//   },
// ];

// const ReferralRewards = () => {
//   return (
//     <div className="container-fluid p-0">

//       {/* 🔹 TOP: Refer Code Section */}
//       <div className="card p-4 mb-4">
//         <h4 className="mb-2">🎁 Refer & Earn</h4>
//         <p className="text-muted">
//           Invite your friends & earn rewards when they place their first order
//         </p>

//         <div className="d-flex align-items-center mb-3">
//           <input
//             type="text"
//             value="REF-NIKITA123"
//             readOnly
//             className="form-control me-2"
//           />
//           <button className="btn btn-success">Copy</button>
//         </div>

//         <ul className="mb-0">
//           <li>✅ You get <b>₹100 coupon</b></li>
//           <li>✅ Friend gets <b>₹50 welcome coupon</b></li>
//         </ul>
//       </div>

//       {/* 🔹 SUMMARY CARDS */}
//       <div className="row mb-4">
//         <div className="col-md-4">
//           <div className="card text-center p-3">
//             <h4 className="text-success">₹200</h4>
//             <p className="mb-0">Total Earned</p>
//           </div>
//         </div>

//         <div className="col-md-4">
//           <div className="card text-center p-3">
//             <h4 className="text-warning">1</h4>
//             <p className="mb-0">Pending</p>
//           </div>
//         </div>

//         <div className="col-md-4">
//           <div className="card text-center p-3">
//             <h4 className="text-secondary">1</h4>
//             <p className="mb-0">Redeemed</p>
//           </div>
//         </div>
//       </div>

//       {/* 🔹 REWARD HISTORY */}
//       <div className="card p-4">
//         <h5 className="mb-3">Reward History</h5>

//         {rewards.map((item, index) => (
//           <div
//             key={index}
//             className="d-flex justify-content-between align-items-center border-bottom py-3"
//           >
//             <div className="d-flex align-items-center">
//               <div
//                 className="rounded-circle bg-dark text-white d-flex align-items-center justify-content-center me-3"
//                 style={{ width: "40px", height: "40px" }}
//               >
//                 {item.name.charAt(0)}
//               </div>

//               <div>
//                 <strong>{item.name}</strong>
//                 <p className="mb-0 text-muted">{item.reward}</p>
//               </div>
//             </div>

//             <div className="text-end">
//               <span
//                 className={`badge ${
//                   item.status === "Earned"
//                     ? "bg-success"
//                     : item.status === "Pending"
//                     ? "bg-warning"
//                     : "bg-secondary"
//                 }`}
//               >
//                 {item.status}
//               </span>
//               <br />
//               <small className="text-muted">{item.date}</small>
//             </div>
//           </div>
//         ))}
//       </div>

//     </div>
//   );
// };

// export default ReferralRewards;


import React from "react";

const rewards = [
  {
    name: "Augustus Waters",
    reward: "₹100 Coupon",
    status: "Earned",
    date: "05 Jul 2024",
  },
  {
    name: "Hazel Grace",
    reward: "₹100 Coupon",
    status: "Pending",
    date: "06 Jul 2024",
  },
  {
    name: "Julia Anna",
    reward: "₹100 Coupon",
    status: "Redeemed",
    date: "07 Jul 2024",
  },
];

const ReferralRewards = () => {
  return (
    <div className="card p-4">

      {/* 🔹 Header */}
      <h4 className="mb-1">Refer & Earn</h4>
      <p className="text-muted mb-3">
        Invite friends and earn coupons when they place their first order
      </p>

      {/* 🔹 Referral Code */}
      <label className="fw-bold mb-1">Your Referral Code</label>
      <div className="d-flex align-items-center mb-3">
        <input
          type="text"
          value="REF-NIKITA123"
          readOnly
          className="form-control me-2"
        />
        <button className="btn btn-outline-success btn-sm">
          Copy
        </button>
      </div>

      {/* 🔹 Reward Rules */}
      <ul className="mb-4">
        <li>You get <b>₹100 coupon</b></li>
        <li>Your friend gets <b>₹50 coupon</b></li>
      </ul>

      {/* 🔹 Reward History */}
      <h6 className="mb-3">Reward History</h6>

      {rewards.map((item, index) => (
        <div
          key={index}
          className="d-flex justify-content-between align-items-center border-bottom py-2"
        >
          <div>
            <strong>{item.name}</strong>
            <div className="text-muted small">{item.reward}</div>
          </div>

          <div className="text-end">
            <span
              className={`badge ${
                item.status === "Earned"
                  ? "bg-success"
                  : item.status === "Pending"
                  ? "bg-warning"
                  : "bg-secondary"
              }`}
            >
              {item.status}
            </span>
            <div className="text-muted small">{item.date}</div>
          </div>
        </div>
      ))}

    </div>
  );
};

export default ReferralRewards;
